<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { SHARED } from "@/constants";
import { mapState } from "vuex";
import { STOCK_OPERATION_MODULE } from "@/state/modules/stockOperation";
import { STOCK_OP_TYPES } from "@/helpers/services/stockOperation.service";
import { stockOperationMethods } from "@/state/helpers";

export default {
  page: { title: i18n.t("label.listingX", [i18n.t("module.stockOperation")]) },
  components: { Layout, PageHeader },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t("module.stockOperation")]),
      opTypes: STOCK_OP_TYPES,
      activeOpType: "receive",
      currentPage: 1,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      fields: [
        { key: "docNo", label: i18n.t("label.docNo") },
        { key: "docDate", label: i18n.t("label.docDate") },
        { key: "location", label: i18n.t("label.location") },
        { key: "description", label: i18n.t("label.description") },
        { key: "total", label: i18n.t("label.total") },
        { key: "action", label: i18n.t("label.action") },
      ],
      searchCriteria: {},
      viewing: null,
      loadingDetail: false,
    };
  },
  computed: {
    ...mapState(STOCK_OPERATION_MODULE, ["status", "details"]),
    tableRows() { return this.$store.state.stockOperation.list.data; },
    pagination() { return this.$store.state.stockOperation.list.pagination; },
  },
  created() {
    this.searchCriteria = { pageNumber: 1, pageSize: SHARED.DEFAULT_PAGE_SIZE };
    this.fetch();
  },
  methods: {
    ...stockOperationMethods,
    fetch() {
      this.getAllStockOperations({ opType: this.activeOpType, filter: this.searchCriteria });
    },
    onTabChange(opType) {
      this.activeOpType = opType;
      this.searchCriteria.pageNumber = 1;
      this.fetch();
    },
    pageNavigation(p) { this.searchCriteria.pageNumber = p; this.fetch(); },
    async openDetail(row) {
      this.viewing = row;
      this.loadingDetail = true;
      this.$bvModal.show("stockOpDetailModal");
      try {
        await this.getStockOperation({ opType: this.activeOpType, docNo: row.docNo });
      } finally {
        this.loadingDetail = false;
      }
    },
    fmtRm(v) {
      const n = Number(v) || 0;
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-alert show variant="info" class="mb-3">
              <i class="mdi mdi-information-outline mr-1"></i>
              Stock operations are managed in AutoCount. This page is read-only.
            </b-alert>
            <b-nav tabs class="mb-3">
              <b-nav-item v-for="t in opTypes" :key="t" :active="activeOpType === t" @click="onTabChange(t)">
                {{ t }}
              </b-nav-item>
            </b-nav>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage">
                <template #cell(action)="data">
                  <a href="javascript:void(0);" @click="openDetail(data.item)" class="text-info" v-b-tooltip.hover :title="$t('label.view')">
                    <i class="mdi mdi-eye-outline font-size-18"></i>
                  </a>
                </template>
              </b-table>
            </div>

            <b-modal id="stockOpDetailModal" :title="viewing ? `${activeOpType.toUpperCase()} — ${viewing.docNo}` : ''" size="lg" hide-footer scrollable>
              <div v-if="loadingDetail" class="text-center py-4">
                <b-spinner small variant="primary"></b-spinner>
              </div>
              <div v-else-if="details && details.docNo">
                <dl class="row mb-3">
                  <dt class="col-sm-3">{{ $t('label.docNo') }}</dt><dd class="col-sm-9">{{ details.docNo }}</dd>
                  <dt class="col-sm-3">{{ $t('label.docDate') }}</dt><dd class="col-sm-9">{{ details.docDate }}</dd>
                  <dt class="col-sm-3">{{ $t('label.location') }}</dt>
                  <dd class="col-sm-9">
                    <b-badge variant="light" class="font-monospace">{{ details.location || '—' }}</b-badge>
                    <span v-if="details.toLocation" class="mx-2"><i class="mdi mdi-arrow-right"></i></span>
                    <b-badge v-if="details.toLocation" variant="info" class="font-monospace">{{ details.toLocation }}</b-badge>
                  </dd>
                  <dt class="col-sm-3">{{ $t('label.description') }}</dt><dd class="col-sm-9">{{ details.description || '—' }}</dd>
                </dl>
                <h6 class="text-muted mb-2">Items ({{ details.items.length }})</h6>
                <b-table small responsive striped :items="details.items" :fields="[
                  { key: 'itemCode', label: $t('label.itemCode') },
                  { key: 'uom', label: $t('label.uom') },
                  { key: 'qty', label: $t('label.qty') },
                  { key: 'unitCost', label: 'Unit Cost', formatter: (v) => fmtRm(v) },
                  { key: 'description', label: $t('label.description') },
                ]" empty-text="No items" show-empty />
              </div>
            </b-modal>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="perPage" @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
